import article from '@/request/api/article'

// 导出接口
export default {
  article
}



// WEBPACK FOOTER //
// ./src/request/api/index.js